import { render, staticRenderFns } from "./_SidebarNormal.vue?vue&type=template&id=60865ce4&scoped=true"
import script from "./_SidebarNormal.vue?vue&type=script&lang=js"
export * from "./_SidebarNormal.vue?vue&type=script&lang=js"
import style0 from "./_SidebarNormal.vue?vue&type=style&index=0&id=60865ce4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60865ce4",
  null
  
)

export default component.exports